import { Component } from "react";
import { setLastInteractionTime } from "../../actions/networkStateActions";
import { AllowableTransversalOrigins } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

export class UserInteraction extends Component {
  constructor(props) {
    super(props);

    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener("message", this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  componentDidUpdate = (prevProps) => {
    let newPathname = this.props.location && this.props.location.pathname;
    if (newPathname !== prevProps.location.pathname) {
      this.props.setLastInteractionTime(Date.now());
    }
  };

  handleMessage(event) {
    if (
      event &&
      Number.isInteger(event.data) &&
      AllowableTransversalOrigins.includes(event.origin)
    ) {
      this.props.setLastInteractionTime(Date.now());
    }
  }

  render() {
    return null;
  }
}

export default withRouter(
  connect(null, { setLastInteractionTime })(UserInteraction)
);
